export enum IncentivesActionType {
	FETCH_TEAM_WISE_SHARE = 'FETCH_TEAM_WISE_SHARE',
	STORE_TEAM_WISE_SHARE = 'STORE_TEAM_WISE_SHARE',

    FETCH_TEAM_WISE_INCENTIVES = 'FETCH_TEAM_WISE_INCENTIVES',
    STORE_TEAM_WISE_INCENTIVES = 'STORE_TEAM_WISE_INCENTIVES',

    FETCH_TEAM_WISE_INCENTIVES_BY_PROJECT_ID = 'FETCH_TEAM_WISE_INCENTIVES_BY_PROJECT_ID',
    STORE_TEAM_WISE_INCENTIVES_BY_PROJECT_ID = 'STORE_TEAM_WISE_INCENTIVES_BY_PROJECT_ID',
}
